// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../../shared/action-creators/busy-counter';
import actions from '../../../action-list';
import {formatClaimNumber} from '../../../../shared/services/format-claim-number';
import {infoAlertBar} from '../../../../shared/services/alert-bar';
import {isClaimEditable} from '../../../shared/services/claim-shared-helper';
import {postClaim} from '../../../shared/repositories';
import {routerActions} from 'react-router-redux';
import {translate} from '../../../../shared/services/translation-service';
import {updateIsActionButtonDisabled} from './is-action-button-disabled';

export const createClaim = claim =>

    async dispatch => {

        updateIsActionButtonDisabled(true)(dispatch);

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const updatedClaim = await postClaim(claim, 'maintenance-plan-claims');

            const selectedAction = updatedClaim.selectedAction.id;

            const validationStatus = updatedClaim.validationFailed;

            infoAlertBar(translate('CLAIM_UPDATED_SUCCESSFULLY'));

            if (['DRAFT', 'SAVE_VALD'].includes(selectedAction) && updatedClaim.claimNumber) {

                dispatch(routerActions.replace(`/claims/maintenance-plan/edit/${formatClaimNumber(updatedClaim.claimNumber)}`));

            }

            dispatch({
                isEditable: isClaimEditable(validationStatus, updatedClaim.selectedAction),
                type: actions.UPDATE_CLAIM_MAINTENANCE_PLAN_IS_EDITABLE
            });

            dispatch({
                type: actions.SET_CLAIM_MAINTENANCE_PLAN,
                updatedClaim
            });

        } catch (error) {

        } finally {

            updateIsActionButtonDisabled(false)(dispatch);

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/claim/marketing/maintenance-plan/action-creators/validate-claim.js